/****************************************************
 * Module Name:  constants.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
export class Constants {

  //Development Service URLs
  // static MANAGER_URL = "http://localhost:8093"; //Manager Service URL
  // static NOTIFICATION_URL = "http://localhost:8091"; //Notification Service URL
  // static WORKER_URL = "http://localhost:8092"; //Worker Service URL
  // static UTILITY_URL = "http://localhost:8094";
  // static HELP_DOCUMENTATION_URL = "https://www.mydiamondinfo.com/help"; //Help Service URL

  // UI Prod
  static MANAGER_URL = "https://www.mydiamondinfo.com:8083"; //Manager Service URL
  static NOTIFICATION_URL = "https://www.mydiamondinfo.com:8081"; //Notification Service URL
  static WORKER_URL = "https://www.mydiamondinfo.com:8082"; //Worker Service URL
  static UTILITY_URL = "https://www.mydiamondinfo.com:8085";
  static HELP_DOCUMENTATION_URL = "https://www.mydiamondinfo.com/help"; //Help Service URL

  // UI Test
  // static MANAGER_URL = "https://www.mydiamondinfo.com:8093"; //Manager Service URL
  // static NOTIFICATION_URL = "https://www.mydiamondinfo.com:8091"; //Notification Service URL
  // static WORKER_URL = "https://www.mydiamondinfo.com:8092"; //Worker Service URL
  // static UTILITY_URL = "https://www.mydiamondinfo.com:8094";
  // static HELP_DOCUMENTATION_URL = "https://www.mydiamondinfo.com/help"; //Help Service URL

  // UI Prod
  // static MANAGER_URL = "https://www.pansuriyaimpex.com/api/manager"; //Manager Service URL
  // static NOTIFICATION_URL = "https://www.pansuriyaimpex.com/api/notification"; //Notification Service URL
  // static WORKER_URL = "https://www.pansuriyaimpex.com/api/worker"; //Worker Service URL
  // static UTILITY_URL = "https://www.pansuriyaimpex.com/api/utility5";
  // static HELP_DOCUMENTATION_URL = "https://www.mydiamondinfo.com/help"; //Help Service URL

  // UI Test
  // static MANAGER_URL = "https://www.pansuriyaimpex.com/api/test/manager"; //Manager Service URL
  // static NOTIFICATION_URL = "https://www.pansuriyaimpex.com/api/test/notification"; //Notification Service URL
  // static WORKER_URL = "https://www.pansuriyaimpex.com/api/test/worker"; //Worker Service URL
  // static UTILITY_URL = "https://www.pansuriyaimpex.com/api/test/utility";
  // static HELP_DOCUMENTATION_URL = "https://www.mydiamondinfo.com/help"; //Help Service URL

  //Company Details
  static COMPANY_NAME = "Pansuriya Impex";
  static COMPANY_SITE = "https://www.pansuriyaimpex.com/";
  static COMPANY_LOGO = ".\\pansuriya.jpg";
  static MAIN_LOGO = ".\\pansuriyaMainLogo.png";

  static loggedInUser = {
    id: 0,
    username: "",
  };

  static STONE_TYPE;

  static newUserPassword = 'admin';

  static defaultTableFontSize = 12;
  static defaultFontWeight = 500;
  static defaultFontWeightBold = 700;

  static userToken = "";

  static USER_PERMISSION = [];

  static USER_COLUMN_PERMISSION = [];

  static COLUMN_PERMISSION = {};

  static NEW_STONE_DAYS;

  static EMPLOYEE_ATTACHED_CUSTOMER_COUNT;

  static pageSize = { pageSize: 500, page: 0 };

  static pageSizeOptions = [50, 100, 200, 500];

  static uniqueFilterValues = {
    shape: [
      { id: 2, label: "Round", value: "ROUND", seq: 1 },
      { id: 3, label: "Pear", value: "PEAR", seq: 2 },
      { id: 4, label: "Princess", value: "PRINCESS", seq: 3 },
      { id: 5, label: "Marquise", value: "MARQUISE", seq: 4 },
      { id: 6, label: "Emerald", value: "EMERALD", seq: 5 },
      { id: 7, label: "Cushion Brilliant", value: "CUSHION BRILLIANT", seq: 6 },
      { id: 8, label: "Cushion Mod", value: "CUSHION MOD", seq: 7 },
      { id: 9, label: "Asscher", value: "ASSCHER", seq: 8 },
      { id: 10, label: "SQ Emerald", value: "SQ EMERALD", seq: 9 },
      { id: 11, label: "Oval", value: "OVAL", seq: 10 },
      { id: 12, label: "Radiant", value: "RADIANT", seq: 11 },
      { id: 13, label: "Heart", value: "HEART", seq: 12 },
      { id: 14, label: "European Cut", value: "EUROPEAN CUT", seq: 13 },
      { id: 15, label: "Old Miner", value: "OLD MINER", seq: 14 },
      { id: 16, label: "Baguette", value: "BAGUETTE", seq: 15 },
      { id: 17, label: "Briolette", value: "BRIOLETTE", seq: 16 },
      { id: 18, label: "Bullets", value: "BULLETS", seq: 17 },
      { id: 19, label: "Calf", value: "CALF", seq: 18 },
      { id: 20, label: "Half Moon", value: "HALF MOON", seq: 19 },
      { id: 21, label: "Hexagonal", value: "HEXAGONAL", seq: 20 },
      { id: 22, label: "Kite", value: "KITE", seq: 21 },
      { id: 23, label: "Lozenge", value: "LOZENGE", seq: 22 },
      { id: 24, label: "Octagonal", value: "OCTAGONAL", seq: 23 },
      { id: 25, label: "Pentagonal", value: "PENTAGONAL", seq: 24 },
      { id: 26, label: "Rose", value: "ROSE", seq: 25 },
      { id: 27, label: "Shield", value: "SHIELD", seq: 26 },
      { id: 28, label: "Square", value: "SQUARE", seq: 27 },
      { id: 29, label: "Square Radiant", value: "SQUARE RADIANT", seq: 28 },
      { id: 30, label: "Star", value: "STAR", seq: 29 },
      { id: 31, label: "Tapered Baguette", value: "TAPERED BAGUETTE", seq: 30 },
      { id: 32, label: "Tapered Bullet", value: "TAPERED BULLET", seq: 31 },
      { id: 33, label: "Trapezoid", value: "TRAPEZOID", seq: 32 },
      { id: 34, label: "Triangular", value: "TRIANGULAR", seq: 33 },
      { id: 35, label: "Trilliant", value: "TRILLIANT", seq: 34 },
      { id: 36, label: "Other", value: "OTHER", seq: 35 },
    ],
    clarity: [
      { id: 3, label: "IF", value: "IF", seq: 2 },
      { id: 4, label: "VVS1", value: "VVS1", seq: 3 },
      { id: 5, label: "VVS2", value: "VVS2", seq: 4 },
      { id: 6, label: "VS1", value: "VS1", seq: 5 },
      { id: 7, label: "VS2", value: "VS2", seq: 6 },
      { id: 9, label: "SI1", value: "SI1", seq: 7 },
      { id: 10, label: "SI2", value: "SI2", seq: 8 },
      { id: 20, label: "I1", value: "I1", seq: 9 },
      { id: 21, label: "I2", value: "I2", seq: 10 },
      { id: 22, label: "I3", value: "I3", seq: 11 },
    ],
    color: [
      { id: 2, label: "D Color", value: "D", seq: 1 },
      { id: 3, label: "E Color", value: "E", seq: 2 },
      { id: 4, label: "F Color", value: "F", seq: 3 },
      { id: 5, label: "G Color", value: "G", seq: 4 },
      { id: 6, label: "H Color", value: "H", seq: 5 },
      { id: 7, label: "I Color", value: "I", seq: 6 },
      { id: 8, label: "J Color", value: "J", seq: 7 },
      { id: 9, label: "K Color", value: "K", seq: 8 },
      { id: 10, label: "L Color", value: "L", seq: 9 },
      { id: 11, label: "M Color", value: "M", seq: 10 },
      { id: 12, label: "N Color", value: "N", seq: 11 },
      { id: 13, label: "O and P Color", value: "O-P", seq: 12 },
      { id: 14, label: "Q and R Color", value: "Q-R", seq: 13 },
      { id: 15, label: "S and T Color", value: "S-T", seq: 14 },
      { id: 16, label: "U and V Color", value: "U-V", seq: 15 },
      { id: 17, label: "W and X Color", value: "W-X", seq: 16 },
      { id: 18, label: "Y and Z Color", value: "Y-Z", seq: 17 },
    ],
    cut: [
      { id: 9, label: "Poor", value: "PR", seq: 6 },
      { id: 10, label: "Fair", value: "FR", seq: 5 },
      { id: 11, label: "Good", value: "GD", seq: 4 },
      { id: 12, label: "Very Good", value: "VG", seq: 3 },
      { id: 13, label: "Excellent", value: "EX", seq: 2 },
      { id: 14, label: "Ideal", value: "ID", seq: 1 }
    ],
    pol: [
      { id: 3, label: "Poor", value: "PR", seq: 6 },
      { id: 4, label: "Fair", value: "FR", seq: 5 },
      { id: 5, label: "Good", value: "GD", seq: 4 },
      { id: 6, label: "Very Good", value: "VG", seq: 3 },
      { id: 7, label: "Excellent", value: "EX", seq: 2 },
      { id: 8, label: "Ideal", value: "ID", seq: 1 },
    ],
    sym: [
      { id: 2, label: "Poor", value: "PR", seq: 6 },
      { id: 3, label: "Fair", value: "FR", seq: 5 },
      { id: 4, label: "Good", value: "GD", seq: 4 },
      { id: 5, label: "Very Good", value: "VG", seq: 3 },
      { id: 6, label: "Excellent", value: "EX", seq: 2 },
      { id: 7, label: "Ideal", value: "ID", seq: 1 }
    ],
    flo: [
      { id: 4, label: "None", value: "NONE", seq: 1 },
      { id: 5, label: "Very Slight", value: "VSL", seq: 2 },
      { id: 6, label: "Slight", value: "SLT", seq: 3 },
      { id: 7, label: "Faint", value: "FNT", seq: 4 },
      { id: 8, label: "Medium", value: "MED", seq: 5 },
      { id: 9, label: "Strong", value: "STG", seq: 6 },
      { id: 10, label: "Very Strong", value: "VST", seq: 7 }
    ],
    lab: [
      { id: 134, label: "IGI", value: "IGI", seq: 2 },
      { id: 135, label: "GIA", value: "GIA", seq: 1 },
      { id: 136, label: "HRD", value: "HRD", seq: 3 }
    ],
    location: [
      { id: 3, label: "MUMBAI", value: "MUMBAI", seq: 1 },
      { id: 20, label: "SURAT", value: "SURAT", seq: 3 },
      { id: 21, label: "HONG KONG", value: "HONG KONG", seq: 2 },
      { id: 94411, label: "NEW YORK", value: "NEW YORK", seq: 4 },
    ],
    country: [
      { id: 1, label: "INDIA", value: "india", seq: 1 },
      { id: 2, label: "HONG KONG", value: "hong kong", seq: 2 }
    ],
    tinge: [
      { id: 1, label: "NONE", value: "NONE", seq: 1 },
      { id: 2, label: "NON", value: "NON", seq: 2 },
      { id: 3, label: "GR1", value: "GR1", seq: 3 },
      { id: 4, label: "GR2", value: "GR2", seq: 4 },
      { id: 5, label: "MIX", value: "MIX", seq: 5 },
      { id: 6, label: "BR", value: "BR", seq: 6 },
      { id: 7, label: "GR", value: "BR", seq: 6 }
    ],
    milky: [
      { id: 1, label: "NONE", value: "NONE", seq: 1 },
      { id: 2, label: "ML 1", value: "ML 1", seq: 2 },
      { id: 3, label: "ML 1.5", value: "ML 1.5", seq: 3 },
      { id: 4, label: "ML 2", value: "ML 2", seq: 4 },
      { id: 5, label: "ML 2.5", value: "ML 2.5", seq: 5 },
      { id: 6, label: "ML 3", value: "ML 3", seq: 6 },
      { id: 7, label: "ML 3.5", value: "ML 3.5", seq: 7 },
      { id: 8, label: "ML 4", value: "ML 4", seq: 8 }
    ],
    colortype: [
      { id: 1, label: "WHITE", value: "WHITE", seq: 1 },
      { id: 2, label: "FANCY", value: "FANCY", seq: 2 },
    ],
    usertype: [
      { id: 1, label: "CUSTOMER", value: "Customer", seq: 1 },
      { id: 2, label: "EMPLOYEE", value: "Employee", seq: 2 },
      { id: 3, label: "BROKER", value: "Broker", seq: 3 },
    ],
    stonetype: [],
    tableinc: [
      { id: 1, label: "B1", value: "B1", seq: 1 },
      { id: 2, label: "B2", value: "B2", seq: 2 },
      { id: 3, label: "B3", value: "B3", seq: 3 },
      { id: 4, label: "FR1", value: "FR1", seq: 4 },
      { id: 5, label: "FR2", value: "FR2", seq: 5 },
      { id: 6, label: "FR3", value: "FR3", seq: 6 },
      { id: 7, label: "CR1", value: "CR1", seq: 7 },
      { id: 8, label: "CR2", value: "CR2", seq: 8 },
      { id: 9, label: "CR3", value: "CR3", seq: 9 },
      { id: 10, label: "CLD1", value: "CLD1", seq: 10 },
      { id: 11, label: "CLD2", value: "CLD2", seq: 11 },
      { id: 12, label: "CLD3", value: "CLD3", seq: 12 },
      { id: 13, label: "PP1", value: "PP1", seq: 13 },
      { id: 14, label: "PP2", value: "PP2", seq: 14 },
      { id: 15, label: "SPR1", value: "SPR1", seq: 15 },
      { id: 16, label: "SPR2", value: "SPR2", seq: 16 },
      { id: 17, label: "SPR3", value: "SPR3", seq: 17 },
      { id: 18, label: "NONE", value: "NONE", seq: 18 }
    ],
    sideinc: [
      { id: 1, label: "B1", value: "B1", seq: 1 },
      { id: 2, label: "B2", value: "B2", seq: 2 },
      { id: 3, label: "B3", value: "B3", seq: 3 },
      { id: 4, label: "FR1", value: "FR1", seq: 4 },
      { id: 5, label: "FR2", value: "FR2", seq: 5 },
      { id: 6, label: "FR3", value: "FR3", seq: 6 },
      { id: 7, label: "CR1", value: "CR1", seq: 7 },
      { id: 8, label: "CR2", value: "CR2", seq: 8 },
      { id: 9, label: "CR3", value: "CR3", seq: 9 },
      { id: 10, label: "CLD1", value: "CLD1", seq: 10 },
      { id: 11, label: "CLD2", value: "CLD2", seq: 11 },
      { id: 12, label: "CLD3", value: "CLD3", seq: 12 },
      { id: 13, label: "PP1", value: "PP1", seq: 13 },
      { id: 14, label: "PP2", value: "PP2", seq: 14 },
      { id: 15, label: "SPR1", value: "SPR1", seq: 15 },
      { id: 16, label: "SPR2", value: "SPR2", seq: 16 },
      { id: 17, label: "SPR3", value: "SPR3", seq: 17 },
      { id: 18, label: "NONE", value: "NONE", seq: 18 }
    ],
    hna: [
      { id: 51533, label: "EX", value: "EX", seq: 1 },
      { id: 51534, label: "VG", value: "VG", seq: 2 },
      { id: 51535, label: "NONE", value: "NONE", seq: 3 }
    ],
    eyeclean: [
      { id: 51536, label: "YES", value: "YES" },
      { id: 51537, label: "NO", value: "NO" }
    ],
    open: [
      { id: 1, label: "HL", value: "HL", seq: 1 },
      { id: 2, label: "SM", value: "SM", seq: 2 },
      { id: 3, label: "MD", value: "MD", seq: 3 },
      { id: 4, label: "HV", value: "HV", seq: 4 },
      { id: 5, label: "NONE", value: "NONE", seq: 5 }
    ],
    luster: [
      { id: 1, label: "EX", value: "EX", seq: 1 },
      { id: 2, label: "VG", value: "VG", seq: 2 },
      { id: 3, label: "NONE", value: "NONE", seq: 3 },
      { id: 4, label: "GD", value: "GD", seq: 4 }
    ]
  }

  static labReportFileType = {
    IGI: "xls",
    GIA: "xlsx",
    HRD: "xls",
  };

  static USER_TYPE = {
    E: "EMPLOYEE",
    C: "CUSTOMER",
    B: "BROKER",
  };

  static TITLES = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
  ];

  static TRREATMENT_TYPE = {
    H: "HPHT",
    C: "CVD"
  };

  static STONE_STATUS = [
    { value: ["AVAILABLE", "HOLD", "MEMO_OUT"], label: "-- ANY --" },
    { value: "AVAILABLE", label: "AVAILABLE" },
    { value: "HOLD", label: "HOLD" },
    { value: "MEMO_OUT", label: "MEMO OUT" },
  ];

  static STONE_UPLOAD_TYPE = [
    { value: 'MANUFACTURING', label: 'MANUFACTURING' },
    { value: 'STOCK', label: 'STOCK' }
  ];

  static CURRENCY_TYPE = [
    { value: 'USD', label: 'USD' },
    { value: 'EURO', label: 'EURO' },
    { value: 'INR', label: 'INR' },
  ];

  static DNK_UPLOAD_TYPE = [
    { value: 'INVOICE', label: 'INVOICE' },
    // add more if needed
  ];

  static GRADES = ["A+", "A", "B", "C", "D"];

  static PERMISSION_TYPE = ["READ", "UPDATE", "DELETE", "ADD"];

  static MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  static MAX_INTEGER = 2147483647;

  //Write all Notification Restricted Users (username) for notification modal in lowercase
  static RESTRICTED_NOTIFICATION_USERS = ["bot"];

  //Write all Support Users (username) for notification modal in lowercase
  static SUPPORT_USERS = ["support"];

  static SnackBarCloseTimer = 3000;

  static CHART_COLORS = [
    [
      "#58508d",
      "#bc5090",
      "#ff6361",
      "#ffa600",
      "#fd7f6f",
      "#7eb0d5",
      "#b2e061",
      "#bd7ebe",
      "#ffb55a",
      "#ffee65",
      "#beb9db",
      "#fdcce5",
      "#8bd3c7",
      "#28a3eb",
      "#1fbd8b",
    ],
    [
      "#ffcdff",
      "#ffadbe",
      "#ffb1a1",
      "#ffbc88",
      "#fdd996",
      "#fdf0a9",
      "#fbfdaa",
      "#e1f6aa",
      "#d3f3ab",
      "#c1f0b2",
      "#bae8c8",
      "#b2e4f0",
      "#c5c8ef",
      "#d6b2f0",
      "#dc94ff",
    ],
    [
      "#142459",
      "#176BA0",
      "#19AADE",
      "#1AC9E6",
      "#1DE4BD",
      "#6DF0D2",
      "#C7F9EE",
      "#29D66B",
      "#7D3AC1",
      "#EA7369",
      "#F0A58F",
      "#FCEAE6",
      "#820406",
      "#EABD3B",
      "#F7F4BF",
    ],
    [
      "#ED6B5B",
      "#3A3E59",
      "#F9AC66",
      "#C36B84",
      "#7D50B9",
      "#4FA3A5",
      "#FE6F9B",
      "#FFBB5A",
      "#684C41",
      "#7F59B0",
      "#F75435",
      "#4FA3A5",
      "#63C5EA",
      "#FA5396",
      "#ED6B5B",
    ],
    [
      "#BFBEBE",
      "#CB8B75",
      "#CAA69A",
      "#A38E76",
      "#BD9655",
      "#D9D2B4",
      "#8B8561",
      "#C3C39D",
      "#627C73",
      "#A6B1B0",
      "#2C3E4A",
      "#412539",
      "#8bd3c7",
      "#C1AF7F",
      "#A28577",
    ],
    [
      "#45ADFF",
      "#BB86FC",
      "#BDDB0B",
      "#E6BC43",
      "#FEA255",
      "#1F8384",
      "#FF74D9",
      "#EC6170",
      "#59EBCB",
      "#34495E",
      "#07B7DC",
      "#6C68FF",
      "#36B64F",
      "#F2B597",
      "#1A5C6C",
    ],
  ];

  static BAR_COLORS = [
    "#7D50B9",
    "#189AB4",
    "#74E7DA",
    "#C36B84",
    "#ED6B5B",
    "#E16BBA",
    "#77BDDF",
    "#F9AC66",
    "#C282FA",
    "#FFBB5A",
    "#FE6F9B",
  ];

  //Style for React Select Component
  static Styles = {
    menuList: (base) => ({
      ...base,
      maxHeight: "150px",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-track": {
        background: "lightgray",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "150px",
      "::-webkit-scrollbar": {
        width: "4px",
      },
      "::-webkit-scrollbar-track": {
        background: "lightgray",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  };

  static DEFAULT_LOCATION = "MUMBAI";
  static DEFAULT_LOCATION_ID = 3;

  static PERMISSIONS = {
    MASTER_USER: 11,
    MASTER_EMPLOYEE: 12,
    MASTER_BROKER: 13,
    MASTER_CUSTOMER: 14,
    MASTER_LAB: 15,
    MASTER_TRADINGCOMPANY: 16,
    MASTER_CLULET: 17,
    OPERATION_STOCK: 18,
    OPERATION_LAB_NEWTEST: 19,
    OPERATION_LAB_LABTESTING: 20,
    OPERATION_LAB_REPORTRECEIVED: 21,
    OPERATION_LAB_STONERECEIVED: 22,
    OPERATION_LAB_APPROVEREJECT: 23,
    OPERATION_LAB_RECHECK: 24,
    OPERATION_LAB_RECHECKDONE: 25,
    OPERATION_MEMO: 26,
    OPERATION_MEMO_ISSUE: 27,
    OPERATION_MEMO_RETURNMANAGE: 28,
    OPERATION_MEMO_SELL: 29,
    OPERATION_MEMO_SEND: 30,
    OPERATION_MEMORECEIVE: 31,
    MIX_SHAPE: 32,
    MIX_SIZE: 33,
    MIX_CLARITY: 34,
    MIX_COLOR: 35,
    MIX_BUCKET: 36,
    MIX_PURCHASE: 37,
    MIX_SALE: 38,
    MIX_VIEW_STOCK: 39,
    MASTER_EYECLEAN: 40,
    STONEJOURNEY_PROCESS: 41,
    MASTER_INCLUSION: 42,
    MASTER_LUSTER: 43,
    MASTER_TINGE: 44,
    MASTER_HNA: 45,
    MASTER_OPEN: 46,
    MASTER_MILKY: 47,
    MASTER_SHADE: 48,
    MASTER_KEYTOSYMBOL: 49,
    MASTER_BUISNESSTYPE: 50,
    MASTER_QUALITY: 51,
    MASTER_EXCHANGERATE: 52,
    MASTER_SIZE: 53,
    MASTER_CUT: 54,
    MASTER_FLO: 55,
    MASTER_SHAPE: 56,
    MASTER_POL: 57,
    MASTER_COLOR: 58,
    MASTER_CLARITY: 59,
    MASTER_SYM: 60,
    MASTER_CUTPOLSYM: 61,
    WORKER: 62,
    WORKER_IGI: 63,
    WORKER_HRD: 64,
    WORKER_SETTING: 65,
    UTILITY_DESIGNATION: 66,
    UTILITY_LOCATION: 67,
    UTILITY_COUNTRY: 68,
    UTILITY_STONESTATUS: 69,
    UTILITY_STONELABSTATUS: 70,
    UTILITY_MEMOSTATUS: 71,
    SETTING: 72,
    SETTING_USERSETTING: 73,
    PERMISSION_PERMISSION: 74,
    PERMISSION_VIRTUALTEAM: 75,
    PERMISSION_ROLE: 76,
    PERMISSION_USERPERMISSION_USER: 77,
    PERMISSION_USERPERMISSION_USERS: 78,
    PERMISSION_USERPERMISSION_VIRTUALTEAM: 79,
    PERMISSION_USERPERMISSION_PERMISSION: 80,
    PERMISSION_USERPERMISSION_PERMISSIONS: 81,
    PERMISSION_USERROLE_USER: 82,
    PERMISSION_USERROLE_VIRTUALTEAM: 83,
    REPORT_USER: 84,
    REPORT_STOCK: 85,
    REPORT_STONEHISTORY: 86,
    REPORT_LABTEST_LABTEST: 87,
    REPORT_LABTEST_PENDINGREPORTRECEIVE: 88,
    REPORT_LABTEST_PENDINGSTONERECEIVE: 89,
    DIRECTRELAB: 90,
    DIRECTOFFLINE: 91,
    OPERATION_STONEPOTENTIAL: 93,
    REPORT_MEMO_REPORTMEMO: 94,
    DIRECTMIX: 95,
    REPORT_PERMISSION_USERWITHOUTPERMISSION: 96,
    OPERATION_NEWSTONE: 97,
    MIX_REPORT_PURCHASE: 98,
    MIX_REPORT_SALES: 99,
    MIX_REPORT_MIXAVG: 100,
    MIX_REPORT_BUCKETTRANSACTION: 101,
    DIRECTSALE: 102,
    REPORT_SALES_INVOICE: 103,
    OPERATION_LAB_PRICING: 104,
    OPERATION_LAB_TAGGING: 105,
    SALES_PROFORMA: 106,
    REPORT_SALES_PROFORMA: 107,
    MANUFACTURING_MASTER_DEPARTMENTGROUP: 108,
    MANUFACTURING_MASTER_DEPARTMENT: 109,
    MIX_SALES_CANCEL_SALE: 110,
    MANUFACTURING_OPERATION_LOTINTIMATION: 111,
    MANUFACTURING_OPERATION_LOTCREATION: 112,
    MANUFACTURING_OPERATION_KAPANCREATION: 113,
    MANUFACTURING_REPORT_PENDINGLOTRECEIVE: 114,
    MANUFACTURING_OPERATION_ISSUERECEIPT: 115,
    MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT: 116,
    UPDATEINVOICEDATA: 117,
    OPERATION_LAB_PRICINGAPPROVAL: 118,
    OPERATION_CHANGELOCATION_CHANGELOCATION: 119,
    OPERATION_CHANGELOCATION_RECEIVELOCATION: 120,
    OPERATION_STONEHOLD_HOLD: 121,
    DIRECTINVOICE: 122,
    MIX_REPORT_INVOICE: 123,
    MIX_REPORT_PROFORMA: 124,
    MIX_SALES_PROFORMA: 125,
    OPERATION_LAB_AVAILABLE: 126,
    UPDATEMIXINVOICEDATA: 127,
    REPORT_COMMISSION_COMMISSION: 128,
    REPORT_COMMISSION_PAYMENT: 129,
    REPORT_COMMISSION_HISTORY: 130,
    MANUFACTURING_PACKAGING: 132,
    MANUFACTURING_REPORT_KAPANHISTORYDETAIL: 133,
    MANUFACTURING_REPORT_KAPANLIST: 134,
    MANUFACTURING_OPERATION_PACKETISSUE: 135,
    MANUFACTURING_OPERATION_PACKETRECEIVE: 136,
    MANUFACTURING_OPERATION_PACKETASSIGN: 137,
    REPORT_USERS_ABOVEMEMODAYS: 138,
    REPORT_USERS_ABOVEPAYMENTDAYS: 139,
    REPORT_USERS_MAXALLOWEDMEMOAMOUNT: 140,
    REPORT_USERS_MAXMEMOREMINDERPERIODSDAYS: 141,
    REPORT_USERS_ABOVEPAYMENTREMINDERDAYS: 142,
    MANUFACTURING_MASTER_REMARK: 143,
    MANUFACTURING_MASTER_LOSS: 144,
    LOTDETAIL: 145,
    LOSSREMARK: 146,
    MANUFACTURING_PACKET_REMARK: 147,
    MANUFACTURING_REPORT_LOSS_USER: 148,
    MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE: 149,
    MANUFACTURING_REPORT_LOSS_KAPANLOSS: 150,
    MANUFACTURING_ADD_EVALUATION: 151,
    MANUFACTURING_OPERATION_REPRINTBARCODE: 152,
    MANUFACTURING_OPERATION_ADDVIDEOURL: 153,
    MANUFACTURING_OPERATION_CONVERTTOSTONE: 154,
    REPORT_KAPAN_KAPANSTATUSSUMMARY: 155,
    MANUFACTURING_OPERATION_CONVERTTOBUCKET: 156,
    REPORT_USERS_CUSTOMERWISEPENDINGPAYMENT: 157,
    STONEINVOICEPAYMENT: 158,
    MIXINVOICEPAYMENT: 159,
    NOTIFICATIONBROADCASTTOALL: 160,
    MASTER_CUSTOMER_FTPSETTING: 161,
    OPERATION_SELL_TO_OUTSOURCE: 162,
    OPERATION_RAPNET_UPLOAD: 163,
    MASTER_RAPNET_LOGINS: 164,
    WORKER_GIA: 165,
    UTILITY_DOCUMENTTYPE: 166,
    STONE: 167,
    SALES_CANCEL_SALE: 168,
    DIRECTHOLD: 169,
    STONEDETAIL: 170,
    STONEDETAIL_SALES: 171,
    STONEDETAIL_MANUFACTURING: 172,
    STONEDETAIL_LAB: 173,
    MASTER_FANCY_COLOR: 174,
    DIRECTOFFER: 175,
    REPORT_STONESEARCHHISTORY: 176,
    OPERATION_OFFER: 177,
    OPERATION_REVISE_STOCK: 178,
    OPERATION_REVISE_AVERAGE: 179,
    PERMISSION_USERCOLUMNPERMISSION_USER: 180,
    PERMISSION_USERCOLUMNPERMISSION_USERS: 181,
    PERMISSION_USERCOLUMNPERMISSION_VIRTUALTEAM: 182,
    OPERATION_STOCKTALLY: 183,
    STONEDETAIL_MEMO_REQUESTED: 184,
    STONEDETAIL_MEMO_OUT: 185,
    MASTER_BOX: 186,
    REPORT_ACCOUNTS_PROFORMA: 187,
    REPORT_ACCOUNTS_INVOICE: 188,
    REPORT_STOCKTALLY: 189,
    PERMISSION_USERCOLUMNPERMISSION_PERMISSION: 190,
    PERMISSION_USERCOLUMNPERMISSION_PERMISSIONS: 191,
    ANALYSIS_NIVODA_CRITERIA: 192,
    PERMISSION_COLUMNROLE: 193,
    PERMISSION_USERCOLUMNROLE_USER: 194,
    PERMISSION_USERCOLUMNROLE_VIRTUALTEAM: 195,
    ANALYSIS_NIVODA_PRICING: 196,
    REPORT_STOCK_EXPORT: 197,
    OPERATION_MEDIA_TRANSFER: 198,
    ANALYSIS_NIVODA_SHAPE_MAPPING: 199,
    ANALYSIS_NIVODA_STOCK: 200,
    ANALYSIS_WOLZA_EXCELUPLOAD: 201,
    ANALYSIS_WOLZA_CONSIGNEEMASTER: 202,
    ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE: 203,
    ANALYSIS_WOLZA_MAPCONSIGNEE_MANAGE: 204,
    DIRECTEXHIBITION: 205,
    MASTER_REASSIGNCUSTOMER: 206,
    MASTER_POTENTIALSELL: 207,
    ANALYSIS_WOLZA_MARKETSELL: 92,
    STONEDETAIL_SELL_POTENTIAL: 208,
    REPORT_CONSIGNMENT: 209,
    STONETYPE_NATURAL: 210,
    STONETYPE_LABGROWN: 211,
    ANALYSIS_NIVODA_USER: 212,
    MASTER_STONETYPE: 213,
    STONEDETAIL_PROFORMA: 214,
    STONEDETAIL_INVOICE: 215,
    OPERATION_REVERT_PRICE: 216,
    ANALYSIS_DNKDATA_INVOICEUPLOAD: 217,
    MIX_BUCKET_REACTIVATE: 218,
    TENDER_MASTER_MINE: 219,
    BUCKETDETAIL: 220,
    MIX_REPORT_COMMISSION_COMMISSION: 221,
    MIX_REPORT_COMMISSION_PAYMENT: 222,
    MIX_REPORT_COMMISSION_HISTORY: 223,
    MIX_REPORT_ACCOUNT_PROFORMA: 224,
    MIX_REPORT_ACCOUNT_INVOICE: 225,
    MANUFACTURING_OPERATION_PRICEPLANNING: 226,
    MANUFACTURING_OPERATION_LOCKEDPLANNING: 227,
    TENDER_MASTER_COMPANY: 228,
    TENDER_OPERATION_TENDER_LOT: 229,
    TENDER_OPERATION_TENDER: 230,
    TENDER_OPERATION_LOT_PLANNING: 231,
    TENDER_OPERATION_SALES_BID: 232,
    TENDER_OPERATION_BID_PREVIEW_STONE: 233,
    TENDER_OPERATION_MANUFACTURING_BID: 234,
    TENDER_OPERATION_BID_PREVIEW_LOT: 235,
    TENDER_OPERATION_BID_PREVIEW_FINAL_BID_SUMMARY: 236,
    MANUFACTURING_OPERATION_PRICEPLANNING_MARKER: 237,
    MANUFACTURING_OPERATION_LOCKEDPLANNING_MARKER: 238,
    OPERATION_RAPNET_EDIT_REMOVE: 239,
    OPERATION_RAPNET_AFFECTED_STONE: 240,
    REPORT_STOCK_AS_ON_DATE: 241,
    TENDER_REPORT_STATS: 242,
    DIRECTMIXINVOICE: 243,
    MIX_REPORT_CUSTOMER_WISE_PENDING_PAYMENT: 244,
    REPORT_DAY_WISE_STONE_SALES: 245,
    MIX_REPORT_DAY_WISE_STONE_SALES: 246,
    KAPANDETAIL: 247,
    MANUFACTURING_PACKET_PLANNING: 248,
    MANUFACTURING_PACKETDETAIL: 249,
    MASTER_TABLEINC: 250,
    MASTER_SIDEINC: 251,
    TENDER_OPERATION_BID_PREVIEW_DIRECTSTONE: 252,
    STONEJOURNEY_MEDIABUILDER: 253,
    MASTER_CUSTOMER_APISETTING: 254,
    TENDER_OPERATION_TENDER_LOT_PLANNING: 255,
    MANUFACTURING_MASTER_PROCESS: 256,
    MANUFACTURING_MASTER_USERPROCESS: 257,
    DIRECT_EXCEL_DOWNLOAD_FULL: 258,
    SUPER_USER: 259,
    REPORT_ACCOUNTS_PROFORMA_HISTORY: 260,
    MASTER_ROUGH_ORIGIN: 261,
    INVOICEDETAIL: 262,
    PERFORMADETAIL: 263,
  };

  static RFID_API = "ws://localhost:8765/rf";

  static DEFAULT_NO_OF_DIGITS = 2;

  static COOKIE_EXPIRES = () => {
    let twoHours = new Date();
    return new Date(twoHours.setHours(twoHours.getHours() + 10));
  };

  static APiFailErrorMessage = "Oops! Something went wrong. Please refresh and try again later.";

  static STONE_TRANSIT_STATUS = {
    NEW: "READY_TO_TRANSIT",
    SENT: "IN_TRANSIT",
    RECEIVED: "READY_TO_DELIVER",
    DELIVERED: "DELIVERED"
  }

  static NIVODA_SHAPES = [
    { label: "Round", value: '"Round"' },
    { label: "Oval", value: '"Oval"' },
    { label: "Princess", value: '"Princess"' },
    { label: "Emerald", value: '"Emerald"' },
    { label: "Sq. emerald", value: '"Sq. emerald"' },
    { label: "Asscher", value: '"Asscher"' },
    { label: "Cushion (all)", value: '"Cushion (all)"' },
    { label: "Marquise", value: '"Marquise"' },
    { label: "Pear", value: '"Pear"' },
    { label: "Sq.radiant", value: '"Sq.radiant"' },
    { label: "Radiant", value: '"Radiant"' },
    { label: "Heart", value: '"Heart"' },
    { label: "Old miner", value: '"Old miner"' },
    { label: "Star", value: '"Star"' },
    { label: "Rose", value: '"Rose"' },
    { label: "Square", value: '"Square"' },
    { label: "Half moon", value: '"Half moon"' },
    { label: "Cushion brilliant", value: '"Cushion brilliant"' },
    { label: "Trapezoid", value: '"Trapezoid"' },
    { label: "Flanders", value: '"Flanders"' },
    { label: "Briolette", value: '"Briolette"' },
    { label: "Pentagonal", value: '"Pentagonal"' },
    { label: "Hexagonal", value: '"Hexagonal"' },
    { label: "Octagonal", value: '"Octagonal"' },
    { label: "Triangular", value: '"Triangular"' },
    { label: "Trilliant", value: '"Trilliant"' },
    { label: "Calf", value: '"Calf"' },
    { label: "Shield", value: '"Shield"' },
    { label: "Lozenge", value: '"Lozenge"' },
    { label: "Kite", value: '"Kite"' },
    { label: "European cut", value: '"European cut"' },
    { label: "Baguette", value: '"Baguette"' },
    { label: "Tapered baguette", value: '"Tapered baguette"' },
    { label: "Bullet", value: '"Bullet"' },
    { label: "Tapered bullet", value: '"Tapered bullet"' },
    { label: "Other", value: '"Other"' },
  ];

  static DefaultWolzaLastFetchedDateSetting = "LAST_FETCH_WOLZA_SUMMARY_DATA_MONTH_YEAR";

  static IGI_PRIORITIES = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
  ];

  static NOTIFICATION_LIMIT = 20;

  static STOCK_EXCEL_KEYS = [
    "REPORT", "SHAPE", "ID", "CTS", "COL", "CLA", "CUT", "POL", "SYM", "FLR",
    "MEASUREMENTS", "DEP", "TABLE%", "CR ANG", "LAB", "RAP", "DIS", "PPC",
    "TOTAL", "LOCATION", "STATUS", "KEYTOSYMBOLS", "MEDIA"
  ];

  static STOCK_EXCEL_COLUMNS = [
    { label: "REPORT", key: "REPORT", width: 15 },
    { label: "SHAPE", key: "SHAPE", width: 14 },
    { label: "STONEID", key: "ID", width: 12 },
    { label: "CTS", key: "CTS", width: 8 },
    { label: "COLOR", key: "COL", width: 9 },
    { label: "CLARITY", key: "CLA", width: 10 },
    { label: "CUT", key: "CUT", width: 7 },
    { label: "POL", key: "POL", width: 7 },
    { label: "SYM", key: "SYM", width: 7 },
    { label: "FLR", key: "FLR", width: 8 },
    { label: "MEASUREMENTS", key: "MEASUREMENTS", width: 20 },
    { label: "DEPTH", key: "DEP", width: 9 },
    { label: "TABLE", key: "TABLE%", width: 9 },
    { label: "CR.ANG", key: "CR ANG", width: 10 },
    { label: "LAB", key: "LAB", width: 7 },
    { label: "RAP", key: "RAP", width: 14 },
    { label: "DIS", key: "DIS", width: 12 },
    { label: "PPC", key: "PPC", width: 14 },
    { label: "TOTAL", key: "TOTAL", width: 14 },
    { label: "LOCATION", key: "LOCATION", width: 18 },
    { label: "STATUS", key: "STATUS", width: 16 },
    { label: "KEY TO SYMBOLS", key: "KEYTOSYMBOLS", width: 50 },
    { label: "STONE MEDIA URL", key: "MEDIA", width: 20 },
  ];

  static EXCEL_OPTIONAL_COLUMNS = [
    { label: "TABLE INC", key: "TABLEINC", width: 20 },
    { label: "SIDE INC", key: "SIDEINC", width: 20 },
    { label: "H&A", key: "H_AND_A", width: 20 },
    { label: "EYE CLEAN", key: "EYECLEAN", width: 20 },
    { label: "TINGE", key: "TINGE", width: 20 },
    { label: "MILKY", key: "MILKY", width: 20 },
    { label: "OPEN", key: "OPEN", width: 20 },
    { label: "LUSTER", key: "LUSTER", width: 20 },
    { label: "TABLE BLACK", key: "TABLEBLACK", width: 20 },
    { label: "SIDE BLACK", key: "SIDEBLACK", width: 20 },
  ];

  static PAGE_TITLES = {
    // Dashboard
    DASHBOARD: "Pansuriya Impex",

    // Master
    MASTER_USER: "PI - User Master",
    MASTER_EMPLOYEE: "PI - Employee Master",
    MASTER_BROKER: "PI - Broker Master",
    MASTER_CUSTOMER: "PI - Customer Master",
    MASTER_REASSIGNCUSTOMER: "PI - Reassign Customer",
    MASTER_POTENTIALSELL: "PI - Potential Sell",
    MASTER_LAB: "PI - Lab Master",
    MASTER_TRADINGCOMPANY: "PI - Trading Company Master",
    MASTER_RAPNET_LOGINS: "PI - Rapnet Logins",

    // Operation
    OPERATION_STOCK: "PI - Stock",
    OPERATION_SELL_TO_OUTSOURCE: "PI - Sell to Outsource",
    OPERATION_RAPNET_UPLOAD: "PI - RapNet Upload",
    OPERATION_RAPNET_EDIT_REMOVE: "PI - RapNet Edit / Remove",
    OPERATION_RAPNET_AFFECTED_STONE: "PI - RapNet Affected Stones",

    OPERATION_LAB_NEWTEST: "PI - Lab New Test",
    OPERATION_LAB_LABTESTING: "PI - Lab Testing",
    OPERATION_LAB_REPORTRECEIVED: "PI - Lab Report Received",
    OPERATION_LAB_STONERECEIVED: "PI - Lab Stone Received",
    OPERATION_LAB_APPROVEREJECT: "PI - Lab Approve / Reject",
    OPERATION_LAB_PRICING: "PI - Lab Pricing",
    OPERATION_LAB_PRICINGAPPROVAL: "PI - Lab Pricing Approval",
    OPERATION_LAB_TAGGING: "PI - Lab Tagging",
    OPERATION_LAB_AVAILABLE: "PI - Lab Available",

    OPERATION_MEMO: "PI - Memo",
    OPERATION_MEMO_ISSUE: "PI - Memo Issue",
    OPERATION_MEMO_RETURNMANAGE: "PI - Memo Return",

    OPERATION_NEWSTONE: "PI - New Stone",
    OPERATION_HOLD: "PI - Hold",
    OPERATION_OFFER_OFFERWISE: "PI - Offer (Offerwise)",
    OPERATION_OFFER_STONEWISE: "PI - Offer (Stonewise)",

    OPERATION_REVISE_STOCK: "PI - Revise Stock",
    OPERATION_REVISE_AVERAGE: "PI - Revise Average",

    OPERATION_STOCKTALLY_STOCK: "PI - Tally Stock",
    OPERATION_STOCKTALLY_BOX: "PI - Tally Box",
    OPERATION_STOCKTALLY_GRADING: "PI - Tally Grading",
    OPERATION_STOCKTALLY_PROFORMA_SEND: "PI - Tally Proforma Send",
    OPERATION_STOCKTALLY_PROFORMA_RECEIVE: "PI - Tally Proforma Receive",
    OPERATION_STOCKTALLY_MANUFACTURING_SEND: "PI - Tally Manufacturing Send",
    OPERATION_STOCKTALLY_MANUFACTURING_RECEIVE: "PI - Tally Manufacturing Receive",
    OPERATION_STOCKTALLY_LOCATION_TRANSFER_SEND: "PI - Tally Location Transfer Send",
    OPERATION_STOCKTALLY_LOCATION_TRANSFER_RECEIVE: "PI - Tally Location Transfer Receive",
    OPERATION_STOCKTALLY_OFFLINE: "PI - Tally Offline Stock",

    OPERATION_MEDIA_TRANSFER: "PI - Media Transfer",
    OPERATION_STONEPOTENTIAL: "PI - Stone Potential",
    OPERATION_REVERT_PRICE: "PI - Revert Price",

    // Mix Master
    MIX_MASTER_SHAPE: "PI - Mix Shape Master",
    MIX_MASTER_SIZE: "PI - Mix Size Master",
    MIX_MASTER_CLARITY: "PI - Mix Clarity Master",
    MIX_MASTER_COLOR: "PI - Mix Color Master",
    MIX_BUCKET: "PI - Mix Bucket Master",

    // Mix Operation
    MIX_OPERATION_PURCHASE: "PI - Mix Purchase",
    MIX_OPERATION_SALE: "PI - Mix Sale",

    // Mix Sales
    MIX_SALES_PROFORMA: "PI - Mix Sales Proforma",
    MIX_SALES_CANCEL_SALE: "PI - Mix Sales Cancel",

    // Mix Reports
    MIX_REPORT_VIEW_STOCK: "PI - Mix Report - View Stock",
    MIX_REPORT_PURCHASE: "PI - Mix Report - Purchase",
    MIX_REPORT_SALES: "PI - Mix Report - Sales",
    MIX_REPORT_BUCKETTRANSACTION: "PI - Mix Report - Bucket Transaction",
    MIX_REPORT_MIXAVG: "PI - Mix Report - Average",
    MIX_REPORT_INVOICE: "PI - Mix Report - Invoice",
    MIX_REPORT_PROFORMA: "PI - Mix Report - Proforma",
    MIX_REPORT_COMMISSION_COMMISSION: "PI - Mix Report - Commission",
    MIX_REPORT_COMMISSION_PAYMENT: "PI - Mix Report - Payment",
    MIX_REPORT_COMMISSION_HISTORY: "PI - Mix Report - History",
    MIX_REPORT_CUSTOMER_WISE_PENDING_PAYMENT: "PI - Mix Report - Pending Payment (Customer-wise)",
    MIX_REPORT_DAY_WISE_STONE_SALES: "PI - Mix Report - Daily Stone Sales",
    MIX_REPORT_ACCOUNT_PROFORMA: "PI - Mix Report - Account Proforma",
    MIX_REPORT_ACCOUNT_INVOICE: "PI - Mix Report - Account Invoice",

    // Generic Master
    MASTER_EYECLEAN: "PI - Eye Clean Master",
    MASTER_INCLUSION: "PI - Inclusion Master",
    MASTER_LUSTER: "PI - Luster Master",
    MASTER_TINGE: "PI - Tinge Master",
    MASTER_HNA: "PI - HNA Master",
    MASTER_OPEN: "PI - Open Master",
    MASTER_MILKY: "PI - Milky Master",
    MASTER_CLULET: "PI - Culet Master",
    MASTER_SHADE: "PI - Shade Master",
    MASTER_KEYTOSYMBOL: "PI - Key to Symbol Master",
    MASTER_BUISNESSTYPE: "PI - Business Type Master",
    MASTER_QUALITY: "PI - Quality Master",
    MASTER_EXCHANGERATE: "PI - Exchange Rate Master",
    MASTER_SIZE: "PI - Size Master",
    MASTER_CUT: "PI - Cut Master",
    MASTER_FLO: "PI - FLO Master",
    MASTER_SHAPE: "PI - Shape Master",
    MASTER_POL: "PI - Polish Master",
    MASTER_COLOR: "PI - Color Master",
    MASTER_FANCY_COLOR: "PI - Fancy Color Master",
    MASTER_CLARITY: "PI - Clarity Master",
    MASTER_SYM: "PI - Symmetry Master",
    MASTER_CUTPOLSYM: "PI - Cut / Polish / Symmetry Master",
    MASTER_BOX: "PI - Box Master",
    MASTER_STONETYPE: "PI - Stone Type Master",
    MASTER_TABLEINC: "PI - Table Inclusion Master",
    MASTER_SIDEINC: "PI - Side Inclusion Master",
    MASTER_ROUGH_ORIGIN: "PI - Rough Origin Master",

    // Manufacturing Master
    MANUFACTURING_MASTER_DEPARTMENTGROUP: "PI - Department Group Master",
    MANUFACTURING_MASTER_DEPARTMENT: "PI - Department Master",
    MANUFACTURING_MASTER_PROCESS: "PI - Process Master",
    MANUFACTURING_MASTER_USERPROCESS: "PI - User Process Master",
    MANUFACTURING_MASTER_REMARK: "PI - Remark Master",
    MANUFACTURING_MASTER_LOSS: "PI - Loss Master",

    // Manufacturing Operation
    MANUFACTURING_OPERATION_LOTINTIMATION: "PI - Lot Intimation",
    MANUFACTURING_OPERATION_LOTCREATION: "PI - Lot Creation",
    MANUFACTURING_OPERATION_KAPANCREATION: "PI - Kapan Creation",
    MANUFACTURING_OPERATION_KAPANISSUE: "PI - Kapan Issue",
    MANUFACTURING_OPERATION_KAPANRECEIVE: "PI - Kapan Receive",
    MANUFACTURING_OPERATION_PACKETISSUE: "PI - Packet Issue",
    MANUFACTURING_OPERATION_PACKETRECEIVE: "PI - Packet Receive",
    MANUFACTURING_OPERATION_PACKETASSIGN: "PI - Packet Assign",
    MANUFACTURING_OPERATION_REPRINTBARCODE: "PI - Reprint Barcode",
    MANUFACTURING_OPERATION_ADDVIDEOURL: "PI - Add Video URL",
    MANUFACTURING_OPERATION_CONVERTPACKET: "PI - Convert Packet",
    MANUFACTURING_OPERATION_PRICEPLANNING: "PI - Price Planning",

    // Manufacturing Reports
    MANUFACTURING_REPORT_PENDINGLOTRECEIVE: "PI - Pending Lot Receive Report",
    MANUFACTURING_REPORT_KAPANLIST: "PI - Kapan List Report",
    MANUFACTURING_REPORT_KAPANHISTORYDETAIL: "PI - Kapan History Report",
    MANUFACTURING_REPORT_LOSS_USER: "PI - Loss Report (User)",
    MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE: "PI - Loss Report (Kapan / Time)",
    MANUFACTURING_REPORT_LOSS_KAPANLOSS: "PI - Loss Report (Kapan)",

    // Tender
    TENDER_MASTER_MINE: "PI - Tender Mine Master",
    TENDER_MASTER_COMPANY: "PI - Tender Company Master",
    TENDER_OPERATION_TENDER: "PI - Tender",
    TENDER_OPERATION_TENDER_LOT: "PI - Tender Lot",
    TENDER_OPERATION_LOT_PLANNING: "PI - Lot Planning",
    TENDER_OPERATION_TENDER_LOT_PLANNING: "PI - Tender Lot Planning",
    TENDER_OPERATION_SALES_BID: "PI - Sales Bid",
    TENDER_OPERATION_MANUFACTURING_BID: "PI - Manufacturing Bid",
    TENDER_OPERATION_BID_PREVIEW_STONE: "PI - Bid Preview - Stone",
    TENDER_OPERATION_BID_PREVIEW_DIRECTSTONE: "PI - Bid Preview - Direct Stone",
    TENDER_OPERATION_BID_PREVIEW_LOT: "PI - Bid Preview - Lot",
    TENDER_OPERATION_BID_PREVIEW_FINAL_BID_SUMMARY: "PI - Bid Preview - Final Summary",
    TENDER_REPORT_STATS: "PI - Tender Stats Report",

    // Stone Journey
    STONEJOURNEY_PROCESS: "PI - Stone Journey Process",
    STONEJOURNEY_MEDIABUILDER: "PI - Stone Journey Media Builder",

    // Worker
    WORKER: "PI - Worker",
    WORKER_IGI: "PI - IGI Worker",
    WORKER_HRD: "PI - HRD Worker",
    WORKER_GIA: "PI - GIA Worker",
    WORKER_SETTING: "PI - Worker Settings",

    // Utility
    UTILITY_DESIGNATION: "PI - Designation Utility",
    UTILITY_LOCATION: "PI - Location Utility",
    UTILITY_COUNTRY: "PI - Country Utility",
    UTILITY_STONESTATUS: "PI - Stone Status Utility",
    UTILITY_STONELABSTATUS: "PI - Lab Status Utility",
    UTILITY_MEMOSTATUS: "PI - Memo Status Utility",
    UTILITY_DOCUMENTTYPE: "PI - Document Type Utility",

    // Sales
    SALES_PROFORMA: "PI - Sales Proforma",
    SALES_CANCEL_SALE: "PI - Cancelled Sales",

    // Reports - User
    REPORT_USER: "PI - User Report",
    REPORT_USERS_MAXMEMOREMINDERPERIODSDAYS: "PI - Users: Max Memo Reminder (Days)",
    REPORT_USERS_ABOVEMEMODAYS: "PI - Users: Above Memo Days",
    REPORT_USERS_MAXALLOWEDMEMOAMOUNT: "PI - Users: Max Allowed Memo Amount",
    REPORT_USERS_ABOVEPAYMENTREMINDERDAYS: "PI - Users: Above Payment Reminder Days",
    REPORT_USERS_ABOVEPAYMENTDAYS: "PI - Users: Above Payment Days",
    REPORT_USERS_CUSTOMERWISEPENDINGPAYMENT: "PI - Users: Customer-wise Pending Payment",

    // Reports - Stock
    REPORT_STOCK: "PI - Stock Report",
    REPORT_STOCK_AS_ON_DATE: "PI - Stock As On Date",
    REPORT_DAY_WISE_STONE_SALES: "PI - Day Wise Stone Sales",
    REPORT_STOCKTALLY: "PI - Stock Tally Report",
    REPORT_STOCK_EXPORT: "PI - Stock Export",
    REPORT_STONEHISTORY: "PI - Stone History Report",
    REPORT_STONESEARCHHISTORY: "PI - Stone Search History",
    REPORT_CONSIGNMENT: "PI - Consignment Report",

    // Reports - Lab Test
    REPORT_LABTEST_LABTEST: "PI - Lab Test Report",
    REPORT_LABTEST_PENDINGREPORTRECEIVE: "PI - Pending Report Receive",
    REPORT_LABTEST_PENDINGSTONERECEIVE: "PI - Pending Stone Receive",

    // Reports - Sales
    REPORT_SALES_INVOICE: "PI - Sales Invoice Report",
    REPORT_SALES_PROFORMA: "PI - Sales Proforma Report",

    // Reports - Accounts
    REPORT_ACCOUNTS_INVOICE: "PI - Accounts Invoice Report",
    REPORT_ACCOUNTS_PROFORMA: "PI - Accounts Proforma Report",
    REPORT_ACCOUNTS_PROFORMA_HISTORY: "PI - Accounts Proforma History Report",

    // Reports - Commission
    REPORT_COMMISSION_COMMISSION: "PI - Commission Report",
    REPORT_COMMISSION_PAYMENT: "PI - Commission Payment Report",
    REPORT_COMMISSION_HISTORY: "PI - Commission History Report",

    // Reports - Memo
    REPORT_MEMO_REPORTMEMO: "PI - Memo Report",

    // Reports - Kapan
    REPORT_KAPAN_KAPANSTATUSSUMMARY: "PI - Kapan Status Summary",

    // Reports - Permissions
    REPORT_PERMISSION_USERWITHOUTPERMISSION: "PI - Users Without Permission",

    // Analysis - Nivoda
    ANALYSIS_NIVODA_USER: "PI - Nivoda User Analysis",
    ANALYSIS_NIVODA_SHAPE_MAPPING: "PI - Nivoda Shape Mapping",
    ANALYSIS_NIVODA_CRITERIA: "PI - Nivoda Criteria",
    ANALYSIS_NIVODA_PRICING: "PI - Nivoda Pricing",
    ANALYSIS_NIVODA_STOCK: "PI - Nivoda Stock",

    // Analysis - Wolza
    ANALYSIS_WOLZA_CONSIGNEEMASTER: "PI - Wolza Consignee Master",
    ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE: "PI - Wolza Map Consignee (Create)",
    ANALYSIS_WOLZA_MAPCONSIGNEE_MANAGE: "PI - Wolza Map Consignee (Manage)",
    ANALYSIS_WOLZA_EXCELUPLOAD: "PI - Wolza Excel Upload",
    ANALYSIS_WOLZA_MARKETSELL: "PI - Wolza Market Sell",

    // Analysis - DNK Data
    ANALYSIS_DNKDATA_INVOICEUPLOAD: "PI - DNK Invoice Upload",

    // Permission
    PERMISSION_PERMISSION: "PI - Permission Management",
    PERMISSION_VIRTUALTEAM: "PI - Virtual Team",
    PERMISSION_ROLE: "PI - Role Management",
    PERMISSION_COLUMNROLE: "PI - Column Role Management",
    PERMISSION_USERPERMISSION: "PI - User Permission",
    PERMISSION_USERCOLUMNPERMISSION: "PI - User Column Permission",
    PERMISSION_USERROLE: "PI - User Role",
    PERMISSION_USERCOLUMNROLE: "PI - User Column Role",

    // Setting
    SETTING: "PI - Settings",
    SETTING_USERSETTING: "PI - User Settings",
    SETTING_COLUMN_ORDER_SETTING: "PI - Column Order Settings",

    // Help
    HELP: "PI - Help Center",

    // API Docs
    API_DOCS: "PI - API Documentation",

    // Watchlist
    WATCHLIST: "PI - Watchlist",

    // Not Found
    NOT_FOUND: "PI - Page Not Found"
  };

  static T2A = "YES T2A";
}

export default Constants;
